import React from "react";
import PropTypes from "prop-types";
import { TiDelete } from "react-icons/ti";
import { useDispatch } from "react-redux";
import { deleteUsers } from "store/user/userThunk";
import { toast } from "react-toastify";
import { getAssignedAgents } from "store/teamLead/teamLeadThunk";
import { getUsers } from "store/user/userThunk";

import { getCookie } from "cookies-next";

export default function DeleteAgentModal({ toggleModal, agentName, agentId }) {
  const dispatch = useDispatch();

  const user = getCookie('user')
  //console.log('user: ', user);
  const handleDeleteClick = () => {
    const userID = agentId
    dispatch(deleteUsers(
      {
        userID,
        onSuccess: () => {
          toast.success('Agent deleted successfully')
          //dispatch(updatedAgents({ userID }))
          dispatch(getAssignedAgents());
          if (user == 'admin'){
             dispatch(getUsers())
          }
        }

      }))
    toggleModal()
  }
  return (
    <div className="modal_overlay">
      <div className="w-[500px] bg-white p-6 rounded-lg">
        <div className="flex justify-end">
          <button className="modal_close_button" onClick={toggleModal}>
            <TiDelete size={24} className="text-red-400 hover:text-red-600" />
          </button>
        </div>
        <div className="p-6">
          <h2 className="text-xl font-bold text-gray-800">Delete Agent</h2>
          <p className="mt-4 text-gray-600">
            Are you sure you want to delete {agentName}? This action cannot be undone.
          </p>
        </div>
        <div className="modal_actions">
          <button
            type="button"
            className="button_cancel"
            onClick={toggleModal}
          >
            Cancel
          </button>
          <button type="button" className="button_submit" onClick={handleDeleteClick}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

DeleteAgentModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  agentName: PropTypes.string,
};

DeleteAgentModal.defaultProps = {
  agentName: "this agent",
};
